import { browserHistory } from 'react-router';
import {
  all,
  call,
  delay,
  fork,
  put,
  select,
  takeEvery,
  takeLatest,
} from 'redux-saga/effects';
import * as api from '../../services/loyalty_redemption/api_loyalty_redemption';
import * as apiCommon from '../../services/apiCommon';
import * as common from '../sagasCommon';
import * as DocType from '../../constants/constant_doc_types';

export default function* (app) {
  try {
    yield all([
      fork(fetchListLoyaltyRedemptionSaga, app),
      fork(deleteLoyaltyRedemptionFromListSaga, app),
      fork(deleteLoyaltyRedemptionSaga, app),
      fork(fetchLoyaltyRedemptionForSaga, app),
      fork(saveLoyaltyRedemptionSaga, app),
    ]);
  } catch (e) {
    console.error('@saga_loyalty_redemption: ', e.message || e.stack);
    throw e;
  }
}

function* fetchListLoyaltyRedemptionSaga(app) {
  yield takeLatest(
    'FETCH_LIST_LOYALTY_REDEMPTION',
    callFetchListLoyaltyRedemption,
    app
  );
}

function* callFetchListLoyaltyRedemption(app, action) {
  const { filters, silent } = action;
  yield common.showProgressListTable(silent);
  try {
    const dataParams = {
      filters,
      list_type: 'loyalty_redemption',
    };
    const tableData = yield call(apiCommon.getDocs, app, dataParams);
    yield call(common.doneListTable, {
      rows: tableData.data,
      total_rows: tableData.total,
    });
  } catch (error) {
    yield common.showErrorListTable(error);
  }
}

function* deleteLoyaltyRedemptionFromListSaga(app) {
  yield takeEvery(
    'DELETE_LOYALTY_REDEMPTION_FROM_LIST',
    callDeleteLoyaltyRedemptionFromList,
    app
  );
}

function* callDeleteLoyaltyRedemptionFromList(app, action) {
  yield deleteLoyaltyRedemption(app, action);
  yield delay(2000);
  yield callFetchListLoyaltyRedemption(app, { silent: true });
}

function* deleteLoyaltyRedemption(app, action) {
  yield put({ type: 'DELETE_RECORD_INPROGRESS' });
  try {
    const { id } = action;
    let result = null;
    if (id) {
      const state = yield select();
      const { tenant, user } = state;
      const { id } = action;
      const params = { tenant, user, id };
      result = yield call(api.deleteLoyaltyRedemption, app, params);
    }
    yield put({
      type: 'DELETE_RECORD_DONE',
      payload: { id, docType: DocType.LOYALTY_REDEMPTION },
    });
    return result;
  } catch (error) {
    yield put({ type: 'DELETE_RECORD_ERROR', error });
  }
}

function* deleteLoyaltyRedemptionSaga(app) {
  yield takeEvery(
    'DELETE_LOYALTY_REDEMPTION',
    callDeleteLoyaltyRedemption,
    app
  );
}

function* callDeleteLoyaltyRedemption(app, action) {
  const result = yield deleteLoyaltyRedemption(app, action);
  yield delay(2000);
  if (result) {
    browserHistory.push('/admin/loyalty/payment');
  }
}

function* fetchLoyaltyRedemptionForSaga(app) {
  yield takeEvery(
    'FETCH_LOYALTY_REDEMPTION',
    callFetchLoyaltyRedemption,
    app
  );
}

function* callFetchLoyaltyRedemption(app, action) {
  const { tenant, user } = yield select();
  const { id, silent } = action;
  try {
    if (id) {
      yield common.showProgressDataById(silent);
      const fetchParams = { tenant, user, id };
      const doc = yield call(
        api.fetchLoyaltyRedemption,
        app,
        fetchParams
      );
      yield common.doneDataById(doc);
    }
  } catch (error) {
    yield put({ type: 'FETCH_DATA_BY_ID_ERROR', error: error });
  }
}

function* saveLoyaltyRedemptionSaga(app) {
  yield takeEvery('SAVE_LOYALTY_REDEMPTION', callSaveLoyaltyRedemption, app);
}

function* callSaveLoyaltyRedemption(app, action) {
  yield common.showProgressSaveRecord();
  const { tenant, user } = yield select();
  try {
    const result = yield call(api.saveLoyaltyRedemption, app, {
      tenant,
      user,
      data: action.data,
    });
    const id = result && result.id;
    yield callFetchLoyaltyRedemption(app, { id, silent: true });
    browserHistory.push(`/admin/loyalty/payment/edit/${id}`);
    yield common.doneSaveRecord(result, 'Payment type was saved');
  } catch (error) {
    yield common.showErrorSaveRecord(error);
  }
}
